import { render, staticRenderFns } from "./strategy_group.vue?vue&type=template&id=481c0494&scoped=true&"
import script from "./strategy_group.vue?vue&type=script&lang=js&"
export * from "./strategy_group.vue?vue&type=script&lang=js&"
import style0 from "./strategy_group.vue?vue&type=style&index=0&id=481c0494&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c0494",
  null
  
)

export default component.exports